import { useI18n } from '../i18n';
import { useAppStore } from '../state/store';
import { MAX_MASTER_GAIN_DB } from '../audio/safety';

export default function VolumeSlider() {
  const { t } = useI18n();
  const masterGainDb = useAppStore((s) => s.masterGainDb);
  const setMasterGainDb = useAppStore((s) => s.setMasterGainDb);

  const formatted = masterGainDb === 0 ? '0' : `+${masterGainDb.toFixed(0)}`;
  const percent = (masterGainDb / MAX_MASTER_GAIN_DB) * 100;

  return (
    <div className="w-[90%] max-w-[560px]">
      <div className="mb-3 flex items-baseline justify-between">
        <label htmlFor="volume-slider" className="text-xl font-medium">
          {t('volume.label')}
        </label>
        <span className="text-2xl font-semibold tabular-nums">
          {formatted} {t('volume.unit')}
        </span>
      </div>
      <input
        id="volume-slider"
        type="range"
        min={0}
        max={MAX_MASTER_GAIN_DB}
        step={1}
        value={masterGainDb}
        onChange={(e) => setMasterGainDb(Number(e.target.value))}
        aria-valuemin={0}
        aria-valuemax={MAX_MASTER_GAIN_DB}
        aria-valuenow={masterGainDb}
        aria-valuetext={`${formatted} ${t('volume.unit')}`}
        className="hb-volume-slider"
        style={{ ['--hb-fill' as string]: `${percent}%` }}
      />
    </div>
  );
}
